module.exports = __webpack_public_path__ + "img/4-removebg-preview.8bb1acca.png";